module.exports = __webpack_public_path__ + "static/img/活动策划案例.93267fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/活动策划案例.png
// module id = gc3y
// module chunks = 3